/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { createSlice } from '@reduxjs/toolkit';
import { TEMP_STORAGE_KEYS } from '../../constants/main';

const initialState = {
  recentBots: JSON.parse(window.localStorage.getItem(TEMP_STORAGE_KEYS.RECENT_BOTS)) || []
};

const botsSlice = createSlice({
  name: 'bots',
  initialState,
  reducers: {
    recentBotsUpdateComplete: (state, action) => {
      window.localStorage.setItem(TEMP_STORAGE_KEYS.RECENT_BOTS, JSON.stringify(action.payload));

      return {
        ...state,
        recentBots: action.payload
      };
    }
  }
});

export const botsActions = botsSlice.actions;

export default botsSlice.reducer;
